// extracted by mini-css-extract-plugin
export default {"pageBg":"AccountsPage_pageBg__4u6tM"};